export default {
  st_config: {
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL
  },
  translation: {
    API_BASE_URL: process.env.VUE_APP_TRANSLATION_API_BASE_URL
  },
  editor_url: process.env.VUE_APP_EDITOR_URL,
  default_url: process.env.VUE_APP_DEFAULT_URL,
  amplitude_key: process.env.VUE_APP_AMPLITUDE_KEY,
  uat_token: process.env.VUE_APP_UAT_TOKEN,
  // Comma-separated origins of the portal shell allowed to postMessage the
  // editor (auth tokens, navigation). Empty = origin check disabled.
  portal_origins: process.env.VUE_APP_PORTAL_ORIGINS
}
